import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {OrdemComponent} from './modules/ordem/ordem.component';
import {CadastrarOrdemComponent} from './modules/ordem/cadastrar-ordem/cadastrar-ordem.component';
import {ListarOrdemComponent} from './modules/ordem/listar-ordem/listar-ordem.component';
import {LoginComponent} from "./modules/login/login/login.component";
import { ErrorPageComponent } from './modules/comum/error-page/error-page.component';
import { RouteGuardService } from './core/apis/orchestrador/api/route-guard.service';
import { LoginIdentifiqueComponent } from './modules/login/login-identifique/login-identifique.component';
import { LogoutComponent } from './modules/logout/logout.component';
import { CartaBaixaPageComponent } from './modules/comum/carta-baixa-page/carta-baixa-page.component';
import { DadosOrdemComponent } from './modules/ordem/dados-ordem/dados-ordem.component';
import { OutrasSolicitacaoComponent } from './modules/ordem/cadastrar-ordem/outras-solicitacao/outras-solicitacao.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'ordem',
    component: OrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'cadastrar-ordem',
    component: CadastrarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'listar-ordem',
    component: ListarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'cadastrar-ordem-outros',
    component: OutrasSolicitacaoComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'listar-ordem/:nroProcesso',
    component: ListarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'detalhar-ordem/:nroProcesso',
    component: DadosOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'carta-baixa',
    component: CartaBaixaPageComponent
  },
  {
    path: 'login-identifique',
    component: LoginIdentifiqueComponent
  },
  {
    path: '**',
    component: ErrorPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
